/**
 * Latladdade serveranrop för skanningen.
 *
 * Skanningens moduler (och deras validering) är tunga och behövs bara när
 * någon faktiskt startar en skanning. Genom att hämta dem först vid anropet
 * hamnar de i ett eget paket i stället för i startsidans JavaScript.
 */
import type * as VideoScan from "./video-scan.functions";
import type * as PhotoScan from "./photo-scan.functions";
import type * as JobQueue from "./job-queue.functions";
import type * as ScanRuns from "./scan-runs.functions";

const videoScan = () => import("./video-scan.functions");
const photoScan = () => import("./photo-scan.functions");
const jobQueue = () => import("./job-queue.functions");
const scanRuns = () => import("./scan-runs.functions");

type Arg<T extends (...args: never[]) => unknown> = Parameters<T>[0];

export const scanVideo = async (opts: Arg<typeof VideoScan.scanVideo>) =>
  (await videoScan()).scanVideo(opts);

export const createScanUpload = async (opts: Arg<typeof VideoScan.createScanUpload>) =>
  (await videoScan()).createScanUpload(opts);

export const createScanFrameUploads = async (
  opts: Arg<typeof VideoScan.createScanFrameUploads>,
) => (await videoScan()).createScanFrameUploads(opts);

export const createVideoScanSession = async (
  opts: Arg<typeof VideoScan.createVideoScanSession>,
) => (await videoScan()).createVideoScanSession(opts);

export const checkpointVideoScanFrame = async (
  opts: Arg<typeof VideoScan.checkpointVideoScanFrame>,
) => (await videoScan()).checkpointVideoScanFrame(opts);

export const reportVideoScanFailure = async (
  opts: Arg<typeof VideoScan.reportVideoScanFailure>,
) => (await videoScan()).reportVideoScanFailure(opts);

export const getJob = async (opts: Arg<typeof JobQueue.getJob>) => (await jobQueue()).getJob(opts);

export const createPhotoScanUploads = async (
  opts: Arg<typeof PhotoScan.createPhotoScanUploads>,
) => (await photoScan()).createPhotoScanUploads(opts);

export const scanPhotos = async (opts: Arg<typeof PhotoScan.scanPhotos>) =>
  (await photoScan()).scanPhotos(opts);

export const savePhotoScanRun = async (opts: Arg<typeof ScanRuns.savePhotoScanRun>) =>
  (await scanRuns()).savePhotoScanRun(opts);
